/**
 * Where Platinum opens once a user is signed in and their customer/job is
 * loaded (Matt + Adam, 9 Sep 2026): the agent start screen is the front door
 * for anyone who can use the agent — "whenever we start Platinum it starts on
 * that page". Everyone else keeps the previous landing, the Tables page.
 *
 * Pure so both callers (login and the already-signed-in redirect) agree, and
 * so the rule is pinned by a test rather than by two hand-copied branches.
 */
export type LandingTarget = { name: string, params: Record<string, string> }

export function postLoginLanding(
  canAccessAgent: boolean,
  customer: string | null | undefined,
  job: string | null | undefined,
): LandingTarget | undefined {
  if (!customer) return undefined
  if (canAccessAgent) return { name: 'agent-new', params: { customer } }
  if (job) return { name: 'tables', params: { customer, job } }
  return undefined
}
